import { createSlice } from "@reduxjs/toolkit";
import { createPersona, editPersona, getPersona } from "./thunk";

const initialState = {
  personaData: [],
  personaLoading: false,
  deleteLoading: false,
  error: null,
};

const personaSlice = createSlice({
  name: "persona",
  initialState,
  reducers: {
    resetPersonaData: (state) => {
      state.personaLoading = false;
      state.personaData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------create persona
      .addCase(createPersona.pending, (state) => {
        state.personaLoading = true;
        state.error = null;
      })
      .addCase(createPersona.fulfilled, (state, action) => {
        state.personaLoading = false;
        state.personaData = action.payload;
      })
      .addCase(createPersona.rejected, (state, action) => {
        state.personaLoading = false;
        state.error = action.payload;
      })

      // ------------------------------------------------------get persona
      .addCase(getPersona.pending, (state) => {
        state.personaLoading = true;
        state.error = null;
      })
      .addCase(getPersona.fulfilled, (state, action) => {
        state.personaLoading = false;
        state.personaData = action.payload;
      })
      .addCase(getPersona.rejected, (state, action) => {
        state.personaLoading = false;
        state.error = action.payload;
      })

      // ------------------------------------------------------get persona
      .addCase(editPersona.pending, (state) => {
        state.personaLoading = true;
        state.error = null;
      })
      .addCase(editPersona.fulfilled, (state, action) => {
        state.personaLoading = false;
        state.personaData = action.payload;
      })
      .addCase(editPersona.rejected, (state, action) => {
        state.personaLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPersonaData } = personaSlice.actions;
export default personaSlice.reducer;
